import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Message } from '../models/app.models';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private messagesSubject = new BehaviorSubject<Message[]>([]);  // Store messages in a BehaviorSubject
  public messages$ = this.messagesSubject.asObservable();  // Expose as an observable

  // Setter to update the messages
  setMessages(messages: Message[]) {
    this.messagesSubject.next(messages);
  }

  // Getter to retrieve the current value of messages
  getMessages(): Message[] {
    return this.messagesSubject.value;
  }

  // Clear the messages if needed
  clearMessages() {
    this.messagesSubject.next([]);
  }
}
